<button
  *ngIf="!!canGroup"
  mat-icon-button
  [matTooltip]="'Group'"
  [intercomTarget]="'toolbar-context-menu-group'"
  (click)="groupSelection.emit()"
>
  <fa-icon [icon]="['far', 'object-group']"></fa-icon>
</button>
<button
  *ngIf="!!canUngroup"
  mat-icon-button
  [matTooltip]="'Ungroup'"
  [intercomTarget]="'toolbar-context-menu-ungroup'"
  (click)="ungroupSelection.emit()"
>
  <fa-icon [icon]="['far', 'object-ungroup']"></fa-icon>
</button>
